import * as yup from 'yup';
import {TFunction} from 'i18next';

export const TITLE_MAX_LENGTH = 50;
export const TITLE_MIN_LENGTH = 3;

export const EMAIL_MAX_LENGTH = 50;

export const WELCOME_MAX_LENGTH = 1000;

export const URL_MAX_LENGTH = 50;
export const IMPRINT_MAX_LENGTH = 100;

const CompanyValidationSchema = (t: TFunction) =>
  yup.object({
    title: yup
      .string()
      .min(
        TITLE_MIN_LENGTH,
        t('validation:min_length', {
          name: t('title'),
          min: TITLE_MIN_LENGTH
        }) || undefined
      )
      .max(
        TITLE_MAX_LENGTH,
        t('validation:max_length', {
          name: t('title'),
          max: TITLE_MAX_LENGTH
        }) || undefined
      )
      .required(
        t('validation:is_required', {
          name: t('title')
        }) || undefined
      ),
    email: yup
      .string()
      .email(t('validation:email_invalid') || undefined)
      .max(
        EMAIL_MAX_LENGTH,
        t('validation:max_length', {
          name: t('email_address'),
          max: EMAIL_MAX_LENGTH
        }) || undefined
      )
      .required(
        t('validation:is_required', {
          name: t('email')
        }) || undefined
      ),
    welcome: yup
      .string()
      .max(
        WELCOME_MAX_LENGTH,
        t('validation:max_length', {
          name: t('welcome_text'),
          max: WELCOME_MAX_LENGTH
        }) || undefined
      )
      .required(
        t('validation:is_required', {
          name: t('welcome_text')
        }) || undefined
      ),

    imprint: yup.object({
      url: yup
        .string()
        .matches(
          /((https):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9\-_.#]+)*\/?(\?[a-zA-Z0-9\-_]+=[a-zA-Z0-9\-_%]+&?)?$/,
          t('validation:url_invalid') || undefined
        )
        .max(
          URL_MAX_LENGTH,
          t('validation:max_length', {
            name: t('url'),
            max: URL_MAX_LENGTH
          }) || undefined
        )
        .required(t('validation:is_required', {name: t('url')}) || undefined),
      labels: yup
        .object()
        .shape({
          de: yup
            .string()
            .max(
              IMPRINT_MAX_LENGTH,
              t('validation:max_length', {
                name: t('label_de'),
                max: IMPRINT_MAX_LENGTH
              }) || undefined
            )
            .required(
              t('validation:is_required', {
                name: t('label_de')
              }) || undefined
            ),
          en: yup
            .string()
            .max(
              IMPRINT_MAX_LENGTH,
              t('validation:max_length', {
                name: t('label_en'),
                max: IMPRINT_MAX_LENGTH
              }) || undefined
            )
            .required(
              t('validation:is_required', {
                name: t('label_en')
              }) || undefined
            )
        })
        .required()
    }),
    allowedSports: yup.array().of(yup.string()).nullable()
  });

export type CompanyInfosSchemaData = yup.InferType<
  ReturnType<typeof CompanyValidationSchema>
>;

export default CompanyValidationSchema;
